import React from 'react';

import './index.scss';
// import modifyImage from 'assets/icon_hensyuu.svg';
import { ReactComponent as ModifyImage } from 'assets/icon_hensyuu.svg';
import { INPUT_URL, CONF_URL, THANKS_URL, ADD_CONF_URL, ADD_THANKS_URL } from 'utils/constant';


const PcTitle = ({ title, path, state }) => {

  const DispTitle = () => {
    return Array.isArray(title) 
      ? title.map(line => (
        <div key={line} className="">
          {line}
          <br />
        </div>
      ))
      : <>{title}</>;
  };
  const { email } = state;
  const InputTitle = () => {
    return (
      <div className="input-sub-title">
        以下のフォームに必要事項をご記入ください。内容を確認の上、担当よりご連絡いたします。
      </div>
    );
  };

  const ConfTitle = () => {
    return (
      <div>
        下記の内容で派遣依頼のご相談を送信します。よろしいですか？
      </div>
    );
  };

  const ThanksTitle = () => {
    return (
      <div>
        ご依頼いただいた内容を
        {' '}
        {email}
        {' '}
        に送付いたしました。
      </div>
    );
  };

  const AddConfTitle = () => {
    return (
      <div>
        ご希望と異なる個所は 
        <span className="modify-icon">
          <ModifyImage />
        </span>
        {/* <img className="modify-icon" src={modifyImage} alt="modify" /> */}
        で修正が可能です。
      </div>
    );
  };

  const AddThanksTitle = () => {
    return (
      <div>
        ご依頼いただいた内容を
        {' '}
        {email}
        {' '}
        に送付いたしました。
      </div>
    );
  };

  const subTitle = {
    [INPUT_URL]: <InputTitle />,
    [CONF_URL]: <ConfTitle />,
    [THANKS_URL]: <ThanksTitle />,
    [ADD_CONF_URL]: <AddConfTitle />,
    [ADD_THANKS_URL]: <AddThanksTitle />,
  };

  return(
  	!title ? <></> :
    <div className="PcTitle">
      <div className="title"><DispTitle title /></div>
      <div className="subTitle">
        {subTitle[path]}
      </div>
    </div>
  );
};

export default PcTitle;
